export default {
  cep: function (input) {
    input = (input.toString()).replace(/\D/g, '')
    const size = input.length
    if (size < 3) {
      input = input.substring(0, 2)
    } else if (size < 6) {
      input = input.substring(0, 2) + '.' + input.substring(2, 5)
    } else {
      input = input.substring(0, 2) + '.' + input.substring(2, 5) + '-' + input.substring(5, 8)
    }
    return input
  },
  cnpj: function (input) {
    input = (input.toString()).replace(/\D/g, '')
    const size = input.length
    if (size < 3) {
      input = input.substring(0, 2)
    } else if (size < 6) {
      input = input.substring(0, 2) + '.' + input.substring(2, size)
    } else if (size < 9) {
      input = input.substring(0, 2) + '.' + input.substring(2, 5) + '.' + input.substring(5, size)
    } else if (size < 13) {
      input = input.substring(0, 2) + '.' + input.substring(2, 5) + '.' + input.substring(5, 8) + '/' + input.substring(8, size)
    } else {
      input = input.substring(0, 2) + '.' + input.substring(2, 5) + '.' + input.substring(5, 8) + '/' + input.substring(8, 12) + '.' + input.substring(12, 14)
    }
    return input
  },
  ie: function (input) {
    input = (input.toString()).replace(/\D/g, '')
    const size = input.length
    if (size > 3) {
      input = input.substring(0, 3) + '/' + input.substring(3, 11)
    }
    return input
  },
  monetario: function (input, forcefive = false) {
    if (input.toString().indexOf('.') === -1) {
      input = input.toString() + '00'
    } else if (input.toString().length - input.toString().indexOf('.') === 2) {
      input = input.toString() + '0'
    }
    input = (input.toString()).replace(/\D/g, '')
    if (forcefive) {
      const l = input.length
      if (l < 5) input += '0'.repeat(5 - l)
    }
    input = parseInt(input).toString()
    const size = input.length
    if (size === 1) {
      input = 'R$ 0,0' + input
    } else if (size === 2) {
      input = 'R$ 0,' + input
    } else if (size < 6) {
      input = 'R$ ' + input.substring(0, size - 2) + ',' + input.substring(size - 2, size)
    } else {
      input = 'R$ ' + input.substring(0, size - 5) + '.' + input.substring(size - 5, size - 2) + ',' + input.substring(size - 2, size)
    }
    return input
  },
  telefone: function (input) {
    input = (input.toString()).replace(/\D/g, '')
    const size = input.length
    if (size < 3) {
      input = input.substring(0, 2)
    } else if (size < 7) {
      input = '(' + input.substring(0, 2) + ') ' + input.substring(2, size)
    } else if (size < 11) {
      input = '(' + input.substring(0, 2) + ') ' + input.substring(2, 6) + '-' + input.substring(6, size)
    } else {
      input = '(' + input.substring(0, 2) + ') ' + input.substring(2, 7) + '-' + input.substring(7, 11)
    }
    return input
  },
  hora: function (input) {
    input = (input.toString()).replace(/\D/g, '')
    const size = input.length
    if (size >= 3) {
      input = input.substring(0, 2) + ':' + input.substring(2, 4)
    }
    return input
  }
}



// WEBPACK FOOTER //
// ./src/components/Mask.js